import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCheckoutSplitAiAnalysis = {
  name: "getCheckoutSplitAiAnalysis" as const,
  input: z.object({
    splitId: zExt.objectId(),
    ignoreCache: z.boolean().optional(),
  }),
  output: z.object({
    analysis: z.string().optional(),
    lastUpdatedAt: zExt.instant().optional(),
  }),
};
